// removed by extract-text-webpack-plugin
module.exports = {"grow-business-page":"grow-business-page","page-title":"page-title","content-box":"content-box","lead":"lead","alert":"alert","alert-info":"alert-info","training-video-card":"training-video-card","video-thumbnail":"video-thumbnail","play-button":"play-button","video-content":"video-content"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/GrowBusiness/GrowBusiness.scss
// module id = 4477
// module chunks = 1